import { BaseBuildPart } from './base-build-part';
import { HelperParams } from './helper-params';
import { Site } from '../../sites';

export class SiteShippingToolBuildPart extends BaseBuildPart {
    constructor(
        private readonly overviewHelperParams: HelperParams,
        parent: BaseBuildPart) {
        super(overviewHelperParams, parent, ['shipment']);
    }

    public inProgressShipmentList(): BaseBuildPart {
        return new BaseBuildPart(this.overviewHelperParams, this, ['inProgressShipment']);
    }

    public submittedShipmentList(): BaseBuildPart {
        return new BaseBuildPart(this.overviewHelperParams, this, ['submittedShipment']);
    }

    public createShipment(): BaseBuildPart {
        return new BaseBuildPart(this.overviewHelperParams, this, ['create']);
    }

    public shipmentSummary(id: number): BaseBuildPart {
        return new BaseBuildPart(this.overviewHelperParams, this, [id, 'view', 'summary']);
    }

    public shipmentSubmittedSummary(id: number): BaseBuildPart {
        return new BaseBuildPart(this.overviewHelperParams, this, [ id, 'submitted', 'summary']);
    }

    public resumeShipment(id: number): BaseBuildPart {
        return new BaseBuildPart(this.overviewHelperParams, this, ['resume', id]);
    }

    public samplesShipmentByProtocol(): BaseBuildPart {
        return new BaseBuildPart(this.overviewHelperParams, this, ['protocol-list']);
    }

    public details(): BaseBuildPart {
        return new BaseBuildPart(this.overviewHelperParams, this, ['details']);
    }
}
